import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as User from '../../helpers/User';
import * as Common from '../../helpers/Common';
import Pagination from '../../helpers/Pagination';

const $= window.$;


class IseekResults extends Component {
	constructor(props) {
		super(props);
		this.state={
            results:[],
            pageOfItems:[],
            title:'',
            sent_date:'',
            sent_to:'',
            received_from:'',
            snap_assigned_id:'',
            feedbacks:[],
            show:'block',
            hide:'none',
        };

		this.fnGetResults = this.fnGetResults.bind(this);
		this.getExcel = this.getExcel.bind(this);
		this.onChangePage = this.onChangePage.bind(this);
	}

	componentWillReceiveProps(nextProps) {

         if(nextProps.feedbacksResults!=undefined){
         	//alert(JSON.stringify(nextProps.feedbacksResults));
         	this.setState({
         		feedbacks: nextProps.feedbacksResults,
         		pageOfItems:nextProps.feedbacksResults,
         		show:'block',
            	hide:'none',
         	})
         }


    }

    onChangePage(pageOfItems) {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }


	getExcel(){
		//alert('im in');
		let assigned_id = this.state.snap_assigned_id;
		let learnerID = Common.getUserData("id", true);
		let domain = Config.domainUrl;
		//alert(assigned_id);
		fetch(Config.domainUrl+'personal/generate-excel', {
                method: 'POST',
                 headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                 },
                  body: JSON.stringify({
                    assignid : assigned_id,learnerID:learnerID, domainUrl:domain
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               	//alert(JSON.stringify(responseJson));
               	let path = Config.domainUrl+'download/admin/'+responseJson.data;
                window.open(path, '_blank');


   		 });
	}

	fnGetResults(assignedid){
		//alert(assignedid);
		let  assignid = assignedid;
		let learnerID = Common.getUserData("id", true);
		fetch(Config.domainUrl+'personal/iseek-getresults', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    assignid : assignid,learnerID:learnerID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               	//alert(JSON.stringify(responseJson));
               	if(responseJson.status != 0 ){
               		
	               	this.setState({
	               		results:responseJson.results,
	               		title:responseJson.snaps.title,
	               		sent_date:responseJson.snaps.sent_date,
	               		sent_to:responseJson.snaps.sent_to,
	               		received_from:responseJson.snaps.received_from,
	               		snap_assigned_id: responseJson.snaps.snap_assigned_id,
	               		show:'none',
            			hide:'block',
	               	});
               	}

   		 });
		// $("#pageContent_fb").hide();
		// $("#Content").show();

	}



		render() {

			//alert(this.state.feedbacks);

			let res = this.state.results.map((result,ke)=>{
				let ans = "";
				if(result.type==1){
					ans = result.answers.map((answ,ki)=>{
						if(answ.answer != ''){
							
								return(
										<div key={`feedresult_${ki}`}>
											<ul>
						                        <li>
						                    		<div className="pollres">{answ.answer}</div>
													<div className="pollprogress"><span style={{width:"100%"}} dangerouslySetInnerHTML={{__html:answ.bar}}/></div>
												</li>
						                    </ul>
										</div>
									)
							
						}
						});
				}
				
				let div_vote = <span className="orgtxt" style={{border:'#FF0000 0px solid'}}>(Total Votes : {result.total_vote})</span>;
				(result.answers.length <= 0 || result.type==2)? div_vote = <div className="view-ans"><a href="javascript:void(0)"  onClick={(e)=>this.getExcel(e)} className="orange1">Click here to view answers</a></div> : div_vote  = div_vote;
				if(result.question!=''){

					return(

								<div key={`fresult_${ke}`} className="fbres-whitebg">
									<span className="bluetxt bluetxt-ans">{result.question}</span>
									{div_vote}
					                <div className="line-fb-page"></div>
					                <div className="inspiration">
									{ans}
									</div>
								</div>

						)
				}
			});

			//const {feedbacksResults} = this.props;
			 let rows = this.state.pageOfItems.map((feedbackresult,i) => {
                return (
		                   <tr key={`feedbackresult_${i}`}>
			                   	<td >{feedbackresult.sno}</td>
				                <td >{feedbackresult.poll_title}</td>
				                <td >{feedbackresult.assigneddate}</td>
				                <td ><img src={process.env.PUBLIC_URL+"/images/viewicon.png"} alt="" onClick={()=>this.fnGetResults(feedbackresult.assigned_id)}/>{(feedbackresult.new_snap!=0)?feedbackresult.new_snap:''}</td>
		                   </tr>
		                )
		       });


		       (rows.length == 0) ? rows = <tr align="center"><td colSpan="4">You have not sought any feedback from your contacts yet. Please send your feedback questionnaire to your contacts and get their feedback.</td></tr> : rows = rows

			return (

	             <div id="ResultpageContent">
		            <div className="fbresulttbl" >
						<div id="pageContent_fb" style={{display:this.state.show}}>
							<table  width="100%" border="0" className="myjourney-table tablesorter" cellPadding="0" cellSpacing="0">
								<thead>
									<tr>
										<th>S.No</th>
										<th>Form Title<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} alt="" title=""/></th>
										<th>Sent date<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} alt="" title=""/></th>
										<th>View results</th>
									</tr>
								</thead>
							  	<tbody>
							  		{rows}
							  	</tbody>
							</table>
							<div className="pull-right">
							<Pagination items={this.state.feedbacks} onChangePage={e=>this.onChangePage(e)} />
							</div>
						</div>
					</div>
					<div id="Content" style={{display:this.state.hide}}>
						<table cellPadding="0" cellSpacing="0" width="100%" border="1" className="myjourney-table" style={{borderCollapse:'collapse', border: 'solid 1px #e7e7e7'}}>

							<tbody>
							<tr>
								<td ><h2 className="bluetxt">{this.state.title}</h2></td>
							</tr>
							<tr id="tr_polls1">
								<td colSpan="3">
									<table border="0" cellPadding="0" width="100%" cellSpacing="0">
										<tbody>
										<tr>
										<td>
										<div className="fbresultpage-bg">
											<div className="fbresulttitbg">
												<div className="fb-result-date">
													Sent Date: {this.state.sent_date}
												</div>
												<div className="fb-result-mail">
													Sent to:&nbsp;{this.state.sent_to}&nbsp;people<br />
													Received from:&nbsp; {this.state.received_from}&nbsp;people
												</div>
											</div>

											{res}

											<div style={{fontWeight:'bold',clear:'both', padding:'15px 0 15px 0px'}}>
												<a href="javascript:void(0)" onClick={(e)=>this.getExcel(e)} className="orange1">Click here to view all answers</a>
											</div>
										</div>
										</td>
										</tr>
										</tbody>
									</table>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			);
		}
}

export default IseekResults;



// WEBPACK FOOTER //
// ./src/personal_interactions/iseek/IseekResults.js